import SmiV2BaseApi from './smiV2BaseApi';


const addAuthHeader = (u, p) => {
  return { 'Authorization': `Basic ${btoa(`${u}:${p}`)}` };
};

export default class SmiV3Instagram extends SmiV2BaseApi {
  getUser({ user, token }) {
    return fetch(`${this.smiv2ApiEndpoint}/v3/users/${user}/${this.serviceName}`, {
      headers: {
        'Content-Type': 'application/json',
        token,
      },
    });
  }

  postUser({ user, token, username, password }) {
    return fetch(`${this.smiv2ApiEndpoint}/v3/users/${user}/${this.serviceName}`, {
      method: 'POST',
      headers: Object.assign((username && password) ? addAuthHeader(username, password) : {}, { token }),
    });
  }

  deleteUser({ user, token }) {
    return fetch(`${this.smiv2ApiEndpoint}/v3/users/${user}/${this.serviceName}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        token,
      },
    });
  }

  postBroadcast({ user, token, title, description, privacyStatus, framerate, resolution, width, height }) {
    return fetch(`${this.smiv2ApiEndpoint}/v3/users/${user}/${this.serviceName}/broadcasts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token,
      },
      body: JSON.stringify({
        title,
        description,
        privacyStatus,
        framerate,
        resolution,
        width,
        height,
      }),
    });
  }

  patchBroadcast({ user, token, broadcastId, broadcastStatus, streamId, liveChatId, chatForwardUrl }) {
    return fetch(`${this.smiv2ApiEndpoint}/v3/users/${user}/${this.serviceName}/broadcasts/${broadcastId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        token,
      },
      body: JSON.stringify({
        broadcastStatus,
        streamId,
        liveChatId,
        chatForwardUrl,
      }),
    });
  }

  // unimplemented
  getBroadcast({ user, token, id, parts }) {}
  getStream({ user, token, id, parts }) {}
}
